<template>
  <div>
    <div class=" w-full">
      <p class=" font-semibold mb-4 inline-block">
        Other Benefits
      </p>
    </div>
    <table aria-label="other benefits table" class=" w-full">
      <thead>
        <tr>
          <th id="0">#</th>
          <th class=" uppercase" v-for="(header, index) in headers" :key="index" :id="index">
            <p>{{ header.title }}</p>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(data, i) in otherBenefitData" :key="i" class="tableBody text-sm" style="height: 48px; ">
          <td>
            {{ i + 1 }}
          </td>
          <td>
            {{ data.payItem.name }}
          </td>
          <td>
            {{ Capitalize(data.payType) }}
          </td>
          <td>
            {{ data.rateType.label }}
          </td>
          <td>
            <c-text v-if="data.isEdit" placeholder="" type="number" v-model="data.rateValue" />
            <span v-else>
              {{`${data.rateValue}%`}}
            </span>
          </td>
          <td>
            {{ convertToCurrency(data.actualAmount) }}
          </td>
          <td>
            <div v-if="data.allowValueFormulaOverride">
              <div v-if="data.isEdit" @click="editRateValue(i)">
                <icon icon-name="close-icon" size="s" class="w-4 h-4 cursor-pointer"/>
              </div>
              <div v-else @click="editRateValue(i)">
                <icon icon-name="red-edit" size="s" class="w-4 h-4 cursor-pointer"/>
              </div>
            </div>
            <div v-else>
              <icon icon-name="red-padlock" size="s" class="w-5 h-5 cursor-pointer"/>
            </div>
          </td>
        </tr>
        <tr class="h-7" />
      </tbody>
    </table>
  </div>
</template>

<script>
import CText from "@scelloo/cloudenly-ui/src/components/text";
import { mapState } from "vuex";

export default {
  components: { CText },
  props: {
    totalGross: {
      type: String,
      default: ""
    },
    otherBenefitData: {
      type: Array,
      default() {
        return [];
      }
    },
    totalGrossEarning: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      // edit: false,
      headers: [
        { title: "pay item" },
        // { title: "name in payslip" },
        { title: "pay type" },
        { title: "rate type" },
        { title: "rate (%)" },
        { title: "amount (₦)" },
        { title: " " }
      ]
    };
  },
  computed: {
    ...mapState({
      employeeDetails: state => state.employee.allEmployeeDetails
    }),
    totalAmount() {
      let result = 0;
      let number = 0;
      this.otherBenefitData.forEach(element => {
        number = parseFloat(element.amount.split(",").join(""));
        result += number;
      });
      result = result.toLocaleString();
      return result;
    }
  },
  methods: {
    editRateValue(i){
      this.$emit('edit-RateValue', i)
    },
  }
};
</script>

<style></style>
